<template>
  <el-select
    ref="select"
    style="width: 100%;"
    :clearable="clearable"
    v-bind="$attrs"
    @input="changeValue"
  >
    <template v-if="!useUrl">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="$te(item.label) ? $t(item.label) : item.label"
        :value="item.value"
      />
    </template>
    <template v-else>
      <el-option
        v-for="item in urlOptions"
        :key="item.enumValue"
        :label="item.enumName"
        :value="item.enumValue"
      />
    </template>
  </el-select>
</template>

<script>
import http from '@/plugin/axios'
export default {
  props: {
    // eslint-disable-next-line
    _options: {
      type: Object,
      default: () => ({})
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      urlOptions: []
    }
  },
  computed: {
    mapKey() {
      return this._options.mapKey
    },
    useUrl() {
      return this._options._useUrl
    },
    options() {
      return this._options.options || []
    }
  },
  async created() {
    if (this.useUrl) {
      const data = await http({
        url: '/sysEnum/getEnumByType',
        baseURL: process.env.VUE_APP_BASE_API,
        data: { enumMid: this.mapKey }
      })
      this.urlOptions = Object.freeze(data)
    }
  },
  methods: {
    changeValue(value, label) {
      const useedOptions = this.useUrl ? this.urlOptions : this.options
      const prop = this.useUrl ? 'enumValue' : this.prop
      const option = useedOptions.filter(i => i[prop] === value)
      const obj = option.length === 1 ? option[0] : {}
      this.$emit('input', value, label, obj)
    }
  }
}
</script>
